/* global fetch */

import { config } from '../config';
import { headers, stleaf, fetchAPIJSON, SpanTag } from '../helpers';

export const list = (st: SpanTag) => {
  const url = `${config.API_URL}/v1/contracts`;
  return fetchAPIJSON(stleaf(st, 'up7tei'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const sign = (st: SpanTag, type, version) => {
  const url = `${config.API_URL}/v1/contracts`;
  return fetchAPIJSON(stleaf(st, 'ko1ees'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({ type, version }),
  });
};
